export const SITE_NAME = "Nohaya";
export const SITE_URL = "https://www.nohaya.com";
// Same-origin in production (CloudFront routes /api/* to the Lambda API).
// Falls back to the CloudFront domain directly for local builds.
export const API_BASE_URL =
  process.env.NEXT_PUBLIC_API_BASE_URL ?? "https://d319bntb2m01dq.cloudfront.net";
export const SITE_DESCRIPTION =
  "Nohaya is the all-in-one platform for AI tools, prompts, resume building, travel guides, and creator voice tools — everything you need, all in one place.";

// Not secrets (both ship to the client either way) -- hardcoded like
// SITE_URL above rather than env vars, so the PHP-served pages
// (php/site-shared/includes/chrome_head.php) can use the same literal
// values without needing their own env-loading story.
export const GA_MEASUREMENT_ID = "G-EPXPPG0VG3";
export const CLARITY_PROJECT_ID = "xehvv4qu01";

export type NavLink = {
  label: string;
  href: string;
};

// Header nav (Header.tsx) -- centre links on desktop, and the top of the
// menu panel on every screen size. Work/Services are sections of the home
// page.
export const HEADER_LINKS: NavLink[] = [
  { label: "Work", href: "/#work" },
  { label: "Services", href: "/#services" },
  { label: "Places", href: "/places" },
  { label: "About", href: "/about" },
];

export type ProductLink = {
  name: string;
  tagline: string;
  href: string;
  icon: string;
  external?: boolean;
};

// "Our products" in the header menu panel.
export const PRODUCT_LINKS: ProductLink[] = [
  {
    name: "Vociva",
    tagline: "AI voice",
    href: "https://play.google.com/store/apps/details?id=com.vociva.app",
    icon: "/home/icon-vociva.webp",
    external: true,
  },
  { name: "Locavia", tagline: "Travel discovery", href: "/locavia", icon: "/home/icon-locavia.webp" },
  { name: "Maila", tagline: "Email cleaner", href: "/maila", icon: "/home/icon-maila.webp" },
  { name: "Stockio", tagline: "Voice billing", href: "/stockio", icon: "/home/icon-stockio.webp" },
];

export const FOOTER_LINKS: { heading: string; links: NavLink[] }[] = [
  {
    heading: "Product",
    links: [{ label: "Places", href: "/places" }, { label: "Pricing", href: "/pricing" }],
  },
  {
    heading: "Company",
    links: [
      { label: "About Us", href: "/about" },
      { label: "Careers", href: "/careers" },
      { label: "Contact", href: "/contact" },
    ],
  },
  {
    heading: "Resources",
    links: [
      { label: "Documentation", href: "/docs" },
      { label: "Help Center", href: "/help" },
      { label: "Community", href: "/community" },
      { label: "Status", href: "/status" },
    ],
  },
  {
    heading: "Legal",
    links: [
      { label: "Privacy Policy", href: "/privacy" },
      { label: "Terms of Service", href: "/terms" },
      { label: "Refund Policy", href: "/refund" },
      { label: "Cookies", href: "/cookies" },
    ],
  },
];
